import ImportFileFrame from "../../components/ImportFileFrame";
import React from "react";
import { FilePanelDescription, FilePanelTitle } from "./index";
import { ButtonImport, ButtonReset } from "../buttons";

const FileUploader = ({
  title,
  description,
  file,
  handleChangeFileChange,
  handleUpload,
  buttonId = '',
}) => {
  return (
    <div className="upload-file__panel 2xl:px-[76px] xl:px-[60px] lg:px-[52px] md:px-[44px] md:py-[20px] xl:py-[24px] w-full flex flex-col space-y-2 ">
      <FilePanelTitle title={title} />
      <FilePanelDescription description={description} className=""/>
      <ImportFileFrame
        name="import_file"
        className="w-full max-w-[800px] 2xl:px-[100px] 2xl:py-[32px] xl:px-[90px] xl:py-[28px] lg:px-[80px] lg:py-[24px] md:py-[18px] md:px-[70px] flex flex-col space-y-[8px] item-center cursor-pointer"
        onFileSelected={handleChangeFileChange}
        file={file}
      />
      <div className="button-group flex justify-center py-6 space-x-[60px]">
        <ButtonReset name="return" />
        <ButtonImport
          className="w-[200px]"
          name="import"
          onClick={handleUpload}
          id={buttonId}
        />
      </div>
    </div>
  );
};

export default FileUploader;
